export default __webpack_public_path__ + "static/dl-f7325ce9f5a4e4d35538ca27de093510.png";